import { render, staticRenderFns } from "./PlatformViewChatbot.vue?vue&type=template&id=5443f176&scoped=true&"
import script from "./PlatformViewChatbot.vue?vue&type=script&lang=js&"
export * from "./PlatformViewChatbot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5443f176",
  null
  
)

export default component.exports